import * as React from "react";

import { cn } from "~/lib/utils";
import { useShape } from "~/lib/shape-context";

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({ className, ...props }, ref) => {
  const shape = useShape();

  return (
    <textarea
      className={cn(
        "control-surface flex field-sizing-content min-h-20 w-full resize-none rounded-2xl p-3.5 text-body transition-[color,box-shadow,background-color] duration-80 outline-none placeholder:text-muted-foreground glider-focus-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:ring-1 aria-invalid:ring-destructive/50",
        shape.input,
        className,
      )}
      data-slot="textarea"
      ref={ref}
      {...props}
    />
  );
});

Textarea.displayName = "Textarea";

export { Textarea };
